// One-shot sign-in rejection message carried across the Cognito hosted-UI logout redirect (sessionStorage survives it; logOut only clears localStorage).
const KEY = "arrivo_signin_flash";

export const setSignInFlash = (message) => {
  try {
    sessionStorage.setItem(KEY, message);
  } catch (e) {
    // storage unavailable (private mode / quota) — the on-page toast is still shown
  }
};

// Read once and delete, so a refresh doesn't repeat it.
export const takeSignInFlash = () => {
  try {
    const message = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return message;
  } catch (e) {
    return null;
  }
};
